import { useEffect }                      from 'react';
import { RouteGuard }                     from './RouteGuard';
import NotFoundComponent                  from 'features/root/NotFoundComponent';
import { AuthRoutes }                     from 'features/auth/index';
import { RootComponent }                  from 'features/root/RootComponent';
import { Route, Routes, 
         useNavigate, 
         useLocation 
       }                                  from 'react-router';
import { CMSPilotHomePage }                  from 'features/cmsPilot/CMSPilotHomePage';
import { PilotDetailsPage }               from 'features/pilot/PilotDetailsPage';
import { RecoHomePage }                   from 'features/recommendations/home/RecoHomePage';
import RecoLayout                         from 'features/recommendations/layout/RecommendationsLayout';
import RecoUploadPage                     from 'features/recommendations/upload/RecoUploadPage';
import RecoComments                       from 'features/recommendations/comments/RecoComments';
import { WorkflowPage }                   from 'features/workflow/WorkflowPage';
import { CustomNodeSpecifications }       from 'features/workflow/CustomNodeSpecifications';
import { UpdateUserMetadata }             from 'features/workflow/UpdateUserMetadata';
import { RecoCreatePage }                 from 'features/recommendations/create/RecoCreatePage';
import { RecoEditPage }                   from 'features/recommendations/create/RecoEditPage';
import { useGlobalConfig }                from 'context/GlobalContext';
import PilotLayout                        from 'features/pilot/layout/PilotLayout';
import UtilityLayout                      from 'features/utility/layout/UtilityLayout';
import { UtilityListPage }                from 'features/utility/UtilityListPage';
import { UtilityHomePage }                from 'features/utility/UtilityDetailsPage';
import { UtilityCreationPage }            from 'features/utility/UtilityCreationPage';
import { UtilityDetailsPage }             from 'features/utility/UtilityDetailsPage';
import { WorkflowListPage }               from 'features/workflow/WorkflowListPage';
import BasePageLayout                     from 'layouts/BasePageLayout';
import { EnvironmentListPage }            from 'features/environments';
import { PilotConfigsPage }             from 'features/pilot/PilotConfigsPage';
import { PilotAssistantPage }           from 'features/pilot/PilotAssistantPage';
import { ApplicationScopePage }         from 'features/pilot/ApplicationScopePage';
import { CustomerDataGeneratorPage } from 'features/pilot/CustomerDataGeneratorPage';
import { EnvironmentCreationStatusPage } from 'features/pilot/EnvironmentCreationStatusPage';
import { DataExtractionStatus } from 'features/workflow/DataExtractionStatus';
import { UserCreationProgress } from 'features/workflow/UserCreationProgress';
import { ApplicationScopeMaster } from 'features/pilot/ApplicationScopeMaster';
import { PipelineMaster } from 'features/pilot/PipelineMaster';
import { PipelineComponentsPage } from 'features/pipeline';
import { DCXClustersPage, DCXClusterCreatePage, FeatureAccessPage, TemplatePersonalizationPage, ConfigComparePage, ConfigCompareReviewPage } from 'features/config-tools';
import CMSApplianceProfilePage               from 'features/cmsPilotProfiles/applianceProfile/CMSApplianceProfilePage';
import CMSHomeProfilePage                    from 'features/cmsPilotProfiles/homeProfile/CMSHomeProfilePage';
import { RecoScorePage }                  from 'features/recommendations/score/RecoScorePage';
import { CMSPilotContentPage }               from 'features/cmsPilot/CMSPilotContentPage';
import { CMSPilotCreationStatusPage }        from 'features/cmsPilot/CMSPilotCreationStatusPage';
import { CMSPilotLayout } from 'features/cmsPilot/layout/CMSPilotLayout';
import { WidgetsSdkDemoPage } from 'components/widgets-sdk-demo/WidgetsSdkDemoPage';
import { ConfigRegistryPage, ConfigRegistryFormPage } from 'features/config-registry';
import { TemplateDetailPage } from 'features/config-registry/pages/TemplateDetailPage';
import WysiwygPage from 'features/contentManagement/wysiwyg/WysiwygPage';
import { SurveyHome } from 'features/survey/home/SurveyHome';
import ColorPalettePage from 'features/contentManagement/colorPalette/ColorPalettePage';
import EditColorPalettePage from 'features/contentManagement/colorPalette/EditColorPalettePage';
import { DataScenariosPage } from 'features/contentManagement/dataScenarios/DataScenariosPage';
import { GlobalDataScenariosPage } from 'features/contentManagement/dataScenarios/GlobalDataScenariosPage';
import { PushUpdatesPage } from 'features/pilot/PushUpdatesPage';
import { UpdateHistoryPage } from 'features/pilot/UpdateHistoryPage';
import { IngestionConfigsPage } from 'features/pilot/IngestionConfigsPage';

export const ROUTE_TREE = {
  ROOT : {path : '/', name : ''},
  AUTH : {path : '/auth/*', name : 'Auth'},
  UTILITY : {
    LAYOUT : {path : '/utility', name : 'Utility'},
    HOME : {path : '/utility/:id', name : 'Project Details'},
   
  },
  PROJECT : {
    LAYOUT : {path : '/project', name : 'Project'},
    LIST : {path : '/project/list', name : 'Projects'},
    CREATE : {path : '/project/create', name : 'Create Project'},
    EDIT : {path : '/project/edit/:projectId', name : 'Update Project Details'},
    CREATE_DETAILS : {path : '/project/create/details', name : 'Project Details'},
    DETAILS : {path : '/project/details', name : 'Project Details'},
    PUSH_UPDATES : {path : '/project/push-updates', name : 'Pending Configuration Push'},
    UPDATE_HISTORY : {path : '/project/update-history', name : 'Update History'},
    INGESTION_CONFIGS : {path : '/project/ingestion-configs', name : 'Ingestion Configurations'},
    APPLICATION_SCOPE : {path : '/project/application-scope', name : 'Application Scope'},
    PIPELINE_COMPONENTS : {path : '/project/pipeline-components', name : 'Pipeline Components'},


    CUSTOMER_DATA_GENERATOR : {path : '/project/customer-data-generator', name : 'Manage Users'},
    ADD_NEW_USER : {path : '/project/add-new-user', name : 'Add New User'},
    UPDATE_METADATA : {path : '/project/customer-data-generator/update-metadata', name : 'Update User Metadata'},
    DATA_EXTRACTION_STATUS : {path : '/project/customer-data-generator/data-extraction-status', name : 'Data Extraction Status'},
    
    CONFIGS: { path: '/project/configs', name: 'Project Configs' },
    ASSISTANT: { path: '/project/assistant', name: 'Project Assistant' },
    ENVIRONMENT_CREATION_STATUS: { path: '/project/environment-creation-status', name: 'Environment Creation Status' },
    USER_CREATION_PROGRESS: {
      path: '/project/customer-data-generator/user-creation-progress',
      name: 'UserCreationProgress'
    },
   
  },
  CMS : {
    LAYOUT : {path : '/cms', name : 'CMS Projects'},
    PROJECT_LIST : {path : '/cms/projects', name : 'CMS Projects'},
    CONTENT : {path : '/cms/project-content', name : 'Content Management'},
    CREATION_STATUS : {path : '/cms/creation-status/:id', name : 'CMS Project Creation Status'},
    APPLIANCE_PROFILE : {path : '/cms/appliance-profile', name : 'Appliance Profile'},
    HOME_PROFILE : {path : '/cms/home-profile', name : 'Home Profile'},
    CONFIG_REGISTRY : {path : '/cms/config-registry', name : 'Configuration Registry'},
    CONFIG_REGISTRY_NEW : {path : '/cms/config-registry/new', name : 'New Configuration'},
    CONFIG_REGISTRY_DETAIL : {path : '/cms/config-registry/:documentId', name : 'Configuration Detail'},
    CONFIG_REGISTRY_TEMPLATE_DETAIL : {path : '/cms/config-registry/templates/:id', name : 'Template Detail'},
    RECO : {
      LAYOUT : {path : '/cms/reco', name : 'Recommendations'},
      COMMENTS : {path : '/cms/reco/comment/:id', name : 'Recommendation Comments'},
      LIST : {path : '/cms/reco/list', name : 'Recommendations'},
      CREATE : {path : '/cms/reco/create', name : 'Create Recommendation'},
      EDIT : {path : '/cms/reco/edit/:id', name : 'Edit Recommendation'},
      UPLOAD : {path : '/cms/reco/upload', name : 'Upload Recommendations'},
      SCORE : {path : '/cms/reco/score', name : 'Recommendation Score Thresholds'},
    },
    SURVEY : {
      HOME : {path : '/cms/survey', name : 'Survey'},
    },
  },
  CONTENT_MANAGEMENT : {
    WYSIWYG : { path: '/content-management/wysiwyg', name: 'CX Visual Editor' },
    COLOR_PALETTE : { path: '/content-management/color-palette', name: 'Color Palette' },
    EDIT_COLOR_PALETTE : { path: '/content-management/color-palette/edit/:standardColorId', name: 'Edit Color Palette' },
    DATA_SCENARIOS : { path: '/content-management/data-scenarios', name: 'Data Scenarios' },
  },
  PILOT : {
    LAYOUT : {path : '/pilot', name : 'Pilot'},
    
  },
  
  WORKFLOW : {
    LAYOUT : {path : '/workflow', name : 'Workflow'},
    LIST : {path : '/workflow/list', name : 'Workflows'},
    HOME : {path : '/workflow/:id', name : 'Workflow'},
    NODE_DETAILS : {path : '/workflow/node/:id', name : 'Component Specifications'},
  },
  ENVIRONMENT : {
    LAYOUT : {path : '/environment', name : 'Environment'},
    LIST : {path : '/environment/list', name : 'Environments'},
  },
  APPLICATION_SCOPE_MASTER : {
    LAYOUT : {path : '/application-scope-master', name : 'Application Scope Master'},
    LIST : {path : '/application-scope-master/list', name : 'Application Scope Master'},
  },
  GLOBAL_DATA_SCENARIOS : {
    LAYOUT : {path : '/global-data-scenarios', name : 'Global Data Scenarios'},
    LIST : {path : '/global-data-scenarios/list', name : 'Global Data Scenarios'},
  },
  PIPELINE : {
    LAYOUT : {path : '/pipeline', name : 'Pipeline'},
    COMPONENTS : {path : '/pipeline/components', name : 'Pipeline Components'},
  },
  PIPELINE_MASTER : {
    LAYOUT : {path : '/pipeline-master', name : 'Pipeline Master'},
    LIST : {path : '/pipeline-master/list', name : 'Pipeline Master'},
  },
  WIDGETS_SDK_DEMO : {
    HOME : {path : '/widgets-sdk-demo', name : 'Widgets SDK Demo'}
  },
  CONFIG_TOOLS : {
    LAYOUT : {path : '/config-tools', name : 'Config Tools'},
    DCX_CLUSTERS : {path : '/config-tools/dcx-clusters', name : 'DCX Clusters'},
    DCX_CLUSTERS_CREATE : {path : '/config-tools/dcx-clusters/create', name : 'Create DCX Cluster'},
    FEATURE_ACCESS : {path : '/config-tools/dcx-clusters/feature-access', name : 'Feature Access'},
    TEMPLATE_PERSONALIZATION : {path : '/config-tools/dcx-clusters/feature-template', name : 'Template Personalization'},
    CONFIG_COMPARE : {path : '/config-tools/config-compare', name : 'Compare & Sync Environments'},
    CONFIG_COMPARE_REVIEW : {path : '/config-tools/config-compare/review', name : 'Review Config Promotion'},
  }
}

export const AppRoutes = () => {

  const { rc } = useGlobalConfig()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    rc.uiRouter.init(navigate)
  }, [navigate, rc.uiRouter])

  useEffect(() => {
    rc.uiRouter.onLocationChange(location)
  }, [location, rc.uiRouter])
  
  return (
    <Routes>
      {/* PUBLIC */}
      <Route path={ROUTE_TREE.ROOT.path} element={<RootComponent/>} />
      
      {/* AUTH */}
      <Route path={ROUTE_TREE.AUTH.path} element={<AuthRoutes/>} />
      
      {/* FEATURE MODULES - PROTECTED */}
      <Route element={<RouteGuard/>}>

        {/* UTILITY */}
        <Route path={ROUTE_TREE.UTILITY.LAYOUT.path} element={<UtilityLayout/>}>
          <Route path={ROUTE_TREE.UTILITY.HOME.path} element={<UtilityHomePage/>}/>
        </Route>

        {/* PROJECT */}
        <Route path={ROUTE_TREE.PROJECT.LAYOUT.path} element={<PilotLayout/>}>
          <Route path={ROUTE_TREE.PROJECT.LIST.path} element={<UtilityListPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.CREATE.path} element={<UtilityCreationPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.EDIT.path} element={<UtilityCreationPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.CREATE_DETAILS.path} element={<UtilityDetailsPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.DETAILS.path} element={<PilotDetailsPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.PUSH_UPDATES.path} element={<PushUpdatesPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.UPDATE_HISTORY.path} element={<UpdateHistoryPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.INGESTION_CONFIGS.path} element={<IngestionConfigsPage/>}/>
          <Route path={ROUTE_TREE.PROJECT.APPLICATION_SCOPE.path} element={<ApplicationScopePage/>}/>
          <Route path={ROUTE_TREE.PROJECT.PIPELINE_COMPONENTS.path} element={<PipelineComponentsPage />} />

          <Route path={ROUTE_TREE.PROJECT.CUSTOMER_DATA_GENERATOR.path} element={<CustomerDataGeneratorPage />} />
          <Route path={ROUTE_TREE.PROJECT.UPDATE_METADATA.path} element={<UpdateUserMetadata />} />
          <Route path={ROUTE_TREE.PROJECT.CONFIGS.path} element={<PilotConfigsPage />} />
          <Route path={ROUTE_TREE.PROJECT.ASSISTANT.path} element={<PilotAssistantPage />} />
          <Route path={ROUTE_TREE.PROJECT.ENVIRONMENT_CREATION_STATUS.path} element={<EnvironmentCreationStatusPage />} />
          <Route path={ROUTE_TREE.PROJECT.DATA_EXTRACTION_STATUS.path} element={<DataExtractionStatus />} />
          <Route path={ROUTE_TREE.PROJECT.USER_CREATION_PROGRESS.path} element={<UserCreationProgress />} />
        </Route>
        
        {/* PILOT */}
        <Route path={ROUTE_TREE.PILOT.LAYOUT.path} element={<PilotLayout/>}>
          
        </Route>

        {/* CMS */}
        <Route path={ROUTE_TREE.CMS.LAYOUT.path} element={<CMSPilotLayout/>}>
          
          {/* PILOT */}
          <Route path={ROUTE_TREE.CMS.PROJECT_LIST.path} element={<CMSPilotHomePage/>}/>
          <Route path={ROUTE_TREE.CMS.CONTENT.path} element={<CMSPilotContentPage/>}/>
          <Route path={ROUTE_TREE.CMS.CREATION_STATUS.path} element={<CMSPilotCreationStatusPage/>}/>

          {/* ATTRIBUTES */}
          <Route path={ROUTE_TREE.CMS.APPLIANCE_PROFILE.path} element={<CMSApplianceProfilePage />} />
          <Route path={ROUTE_TREE.CMS.HOME_PROFILE.path} element={<CMSHomeProfilePage />} />

          {/* CONFIG REGISTRY */}
          <Route path={ROUTE_TREE.CMS.CONFIG_REGISTRY.path} element={<ConfigRegistryPage />} />
          <Route path={ROUTE_TREE.CMS.CONFIG_REGISTRY_NEW.path} element={<ConfigRegistryFormPage />} />
          <Route path={ROUTE_TREE.CMS.CONFIG_REGISTRY_DETAIL.path} element={<ConfigRegistryFormPage />} />
          <Route path={ROUTE_TREE.CMS.CONFIG_REGISTRY_TEMPLATE_DETAIL.path} element={<TemplateDetailPage />} />

          {/* RECOMMENDATIONS */}
          <Route path={ROUTE_TREE.CMS.RECO.LAYOUT.path} element={<RecoLayout/>}>
            <Route path={ROUTE_TREE.CMS.RECO.COMMENTS.path} element={<RecoComments/>}/>
            <Route path={ROUTE_TREE.CMS.RECO.LIST.path} element={<RecoHomePage/>}/>
            <Route path={ROUTE_TREE.CMS.RECO.UPLOAD.path} element={<RecoUploadPage/>}/>
            <Route path={ROUTE_TREE.CMS.RECO.CREATE.path} element={<RecoCreatePage/>}/>
            <Route path={ROUTE_TREE.CMS.RECO.EDIT.path} element={<RecoEditPage/>}/>
            <Route path={ROUTE_TREE.CMS.RECO.SCORE.path} element={<RecoScorePage/>}/>
          </Route>

          {/* SURVEY */}
          <Route path={ROUTE_TREE.CMS.SURVEY.HOME.path} element={<SurveyHome />} />

        </Route>

        {/* Content Management - WYSIWYG Editor - top-level route (not under /cms layout) */}
        <Route path={ROUTE_TREE.CONTENT_MANAGEMENT.WYSIWYG.path} element={<WysiwygPage/>}/>
        <Route path={ROUTE_TREE.CONTENT_MANAGEMENT.COLOR_PALETTE.path} element={<ColorPalettePage/>}/>
        <Route path={ROUTE_TREE.CONTENT_MANAGEMENT.EDIT_COLOR_PALETTE.path} element={<EditColorPalettePage/>}/>
        <Route path={ROUTE_TREE.CONTENT_MANAGEMENT.DATA_SCENARIOS.path} element={<DataScenariosPage/>}/>
        
        {/* Global Data Scenarios */}
        <Route path={ROUTE_TREE.GLOBAL_DATA_SCENARIOS.LAYOUT.path} element={<GlobalDataScenariosPage/>}/>

        {/* WORKFLOW */}
        <Route path={ROUTE_TREE.WORKFLOW.LAYOUT.path} element={<BasePageLayout/>}>
          <Route path={ROUTE_TREE.WORKFLOW.LIST.path} element={<WorkflowListPage />} />
          <Route path={ROUTE_TREE.WORKFLOW.HOME.path} element={<WorkflowPage />} />
          <Route path={ROUTE_TREE.WORKFLOW.NODE_DETAILS.path} element={<CustomNodeSpecifications />} />          
        </Route>

        {/* ENVIRONMENT */}
        <Route path={ROUTE_TREE.ENVIRONMENT.LAYOUT.path} element={<BasePageLayout/>}>
          <Route path={ROUTE_TREE.ENVIRONMENT.LIST.path} element={<EnvironmentListPage />} />
        </Route>

        {/* APPLICATION SCOPE MASTER */}
        <Route path={ROUTE_TREE.APPLICATION_SCOPE_MASTER.LAYOUT.path} element={<BasePageLayout/>}>
          <Route path={ROUTE_TREE.APPLICATION_SCOPE_MASTER.LIST.path} element={<ApplicationScopeMaster />} />
        </Route>

        {/* PIPELINE MASTER */}
        <Route path={ROUTE_TREE.PIPELINE_MASTER.LAYOUT.path} element={<BasePageLayout/>}>
          <Route path={ROUTE_TREE.PIPELINE_MASTER.LIST.path} element={<PipelineMaster />} />
        </Route>
        
        {/* WIDGETS SDK DEMO */}
        <Route path={ROUTE_TREE.WIDGETS_SDK_DEMO.HOME.path} element={<WidgetsSdkDemoPage />} />

        {/* CONFIG TOOLS */}
        <Route path={ROUTE_TREE.CONFIG_TOOLS.LAYOUT.path} element={<BasePageLayout/>}>
          <Route path={ROUTE_TREE.CONFIG_TOOLS.DCX_CLUSTERS.path} element={<DCXClustersPage />} />
          <Route path={ROUTE_TREE.CONFIG_TOOLS.DCX_CLUSTERS_CREATE.path} element={<DCXClusterCreatePage />} />
          <Route path={ROUTE_TREE.CONFIG_TOOLS.FEATURE_ACCESS.path} element={<FeatureAccessPage />} />
          <Route path={ROUTE_TREE.CONFIG_TOOLS.TEMPLATE_PERSONALIZATION.path} element={<TemplatePersonalizationPage />} />
          <Route path={ROUTE_TREE.CONFIG_TOOLS.CONFIG_COMPARE.path} element={<ConfigComparePage />} />
          <Route path={ROUTE_TREE.CONFIG_TOOLS.CONFIG_COMPARE_REVIEW.path} element={<ConfigCompareReviewPage />} />
        </Route>

      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundComponent />} />
    </Routes>
  )
}